import { z } from 'zod';

/**
 * Runtime-validated, typed access to Vite env vars. Import `env` instead of
 * reading `import.meta.env` directly so a missing/malformed value fails loudly
 * at startup rather than silently downstream.
 */
const envSchema = z.object({
  VITE_SITE_URL: z.url().default('http://localhost:5173'),
  VITE_SPLINE_SCENE_URL: z.union([z.url(), z.literal('')]).optional(),
  VITE_API_BASE_URL: z.union([z.url(), z.literal('')]).optional(),
});

export type Env = z.infer<typeof envSchema>;

export const env: Env = envSchema.parse(import.meta.env);
